<template>
  <div>
    <div>
      <v-container>
        <v-layout wrap>
          <v-flex md2 sm12>
            <choose-date :label="$t('common.from')" v-model="start"></choose-date>
          </v-flex>
          <v-flex md2 sm12>
            <choose-date :label="$t('common.to')" v-model="end"></choose-date>
          </v-flex>
        </v-layout>
      </v-container>
     
      <DataTable :url="'captains-complaints-stats'" :enable-edit="false" :enable-add="false" :enable-delete="false"
        :disableSearch="true" :sortable="false" :formatter="formatters" :initial-url-search-params="dateParams"
        :actions-extra-main="actionsExtraMain" perPage="25" :fields-hidden-main="['car', 'cars']" :titles="titles" />

    </div>

  </div>
</template>

<style lang="scss"></style>

<script>
import DataTable from "@/components/monaco/DataTable";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "ComplaintsStats",
  title() {
    return this.$t("monitoring.complaintsStats.title");
  },
  components: { DataTable, ChooseDate },
  data() {
    return {
      stats: [],
      newPosition: null,
      selectedCaptain: null,
      loading: false,
      pagination: {
        rowsPerPage: 25
      },
      start: "",
      end: "",
      formatters: {

      }
    };
  },

  computed: {
    titles() {
      return {
        id: "#",
        username: this.$t("monitoring.complaintsStats.taxiNumber"),
        first_name: this.$t("monitoring.complaintsStats.firstName"),
        last_name: this.$t("monitoring.complaintsStats.lastName"),
        complaints_count: this.$t("monitoring.complaintsStats.complaints")
      };
    },
    dateParams() {
      const params = new URLSearchParams();
      params.append("start", this.start);
      params.append("end", this.end);
      return params;
    },
    actionsExtraMain() {
      return {
        captain: {
          title: this.$t("monitoring.complaintsStats.captainProfile"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              path:"/captains/"+ item.id,
              query: { tab: 7 }
            }),
        },
      };
    },
  },
  methods: {

  },
  mounted() {
    this.start = moment().startOf('month').format("YYYY-MM-DD");
    this.end = moment().format("YYYY-MM-DD");
  
  },
};
</script>
